export default __webpack_public_path__ + "static/media/fraise.2447e45d.png";